import * as React from 'react'

import { getLazyImageObserver } from './getLazyImageObserver'
import { makeLazyReady } from './makeLazyReady'

type LazyWysiwygProps = {
  nativeLazyLoad?: boolean
  children: React.ReactElement<{ dangerouslySetInnerHTML: { __html: string } }>
}

export function LazyWysiwyg({
  nativeLazyLoad = false,
  children,
}: LazyWysiwygProps): React.ReactElement<LazyWysiwygProps> {
  const wrapperRef = React.useRef<HTMLDivElement>(null)

  const lazyImageObserver = getLazyImageObserver()
  const lazyReady = makeLazyReady(children.props.dangerouslySetInnerHTML.__html, nativeLazyLoad)

  React.useEffect(() => {
    if (nativeLazyLoad) {
      return
    }

    if (wrapperRef.current !== null) {
      wrapperRef.current.querySelectorAll('img').forEach((img) => {
        lazyImageObserver.observe(img)
      })
    }

    return () => {
      if (wrapperRef.current !== null) {
        wrapperRef.current.querySelectorAll('img').forEach((img) => {
          lazyImageObserver.unobserve(img)
        })
      }
    }
  }, [])

  const wysiwygWithoutSrc = React.cloneElement(children, { dangerouslySetInnerHTML: { __html: lazyReady } })

  return <div ref={wrapperRef}>{wysiwygWithoutSrc}</div>
}
